module.exports = __webpack_public_path__ + "static/about7-01ab8bb713fe859c85fee3e9fc9e7b32.png";